import { Component, OnInit } from '@angular/core';
import { KeyValuePair } from '../../../models/common/keyValuePair';
import { ParameterService } from '../../../services/parameter.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { AUTH } from '../../../contants/AUTH';
import { AlertService } from '../../../services/alert.service';
import { Event } from '@angular/router';

@Component({
	selector: 'app-parameters',
	templateUrl: './parameters.component.html',
	styleUrls: ['./parameters.component.css']
})
export class ParametersComponent implements OnInit {
	
	parameter: KeyValuePair = new KeyValuePair();
	userId: number = null;
	value: string;

	data:KeyValuePair[] = [];

	isManager: boolean = false;

	constructor(
		private _paramterService: ParameterService,
		private _authService: AuthenticationService,
		private _alertService: AlertService
	) { }

	ngOnInit() {
		this.init();
	}

	init(){
		this._authService.checkRights().subscribe(
			result => {
				this.isManager = result;
			}
		);
		
		this.userId = Number(localStorage.getItem(AUTH.userId));
	}

	getParameterValue(event: Event){
		this._paramterService.getParameter<string>(this.parameter.key, false, 0, this.userId).subscribe(
			result => {
				this.value = result;
			}
		);
	}

	search(searchText: string){
		this._paramterService.searchParameterCode(searchText).subscribe(
			result => {
				this.data = result;
			}
		);
	}

	update(){
		if(isNaN(this.userId)){
			this._alertService.showError('An user should be selected.');
			return;
		}

		if(this.parameter.key == null || this.parameter.key == undefined){
			this._alertService.showError('A valid parameter should be selected.');
			return;
		}

		this._paramterService.updateParameter(this.parameter.key, this.value, this.userId).subscribe(
			result => {
				this._alertService.showSuccess('Parameter was updated.');
			}
		);
	}

}



// WEBPACK FOOTER //
// ./src/app/components/settings/parameters/parameters.component.ts